module.exports = __webpack_public_path__ + "img/icon-20-faq.c7e94bbf.svg";